<template>
    <div class="pt-15 animated fadeIn masterGLaccount staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-table :settings="tableConfig"
                            :table-items="tableItems"
                            @new-item="modals.create.open = true"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @import-items="importItems"
                            @delete-items="deleteItems"
                            ref="gofixTable">
                        </gofix-table>
                    </gofix-card>
                </b-col>
            </b-row>

            <b-modal 
                :no-close-on-backdrop="true" 
                @hidden="hideModelCreate" 
                id="modal-Create"
                title="Create New Checklist Template"
                hide-footer 
                :centered="true" 
                v-model="modals.create.open">
                <b-form class="pb-20">
                    <gofix-form-input label="Name" v-model="modals.create.data.name_checklist_templates" required></gofix-form-input>
                </b-form>
                <b-button-group class="d-block text-right">
                    <!--<gofix-button label="MORE" @click="gotoItem" noBorder dark></gofix-button>-->
                    <gofix-button label="APPLY" @click="saveData" :loading="modals.create.loading" :disabled="$disabledCreateOrUpdate(modals.create.data, $accessModule.checklist_template)" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'checklist-template-master',
        data() {
            let filter = JSON.parse(JSON.stringify(filters['checklist_template']));
            filter.is_master.value = true;
            delete(filter.contract_id);
            return {
                tableConfig:{
                    name: 'contract-checklist',
                    controls:{
                        create: this.$checkRole(this.$accessModule.checklist_template_master, 'create'),
                        delete: this.$checkRole(this.$accessModule.checklist_template_master, 'delete')
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width:50px",
                        },
                        {
                            key: 'id',
                            label: 'Code',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:350px",
                            sorting: true,
                            with:350
                        },
                        {
                            key: 'name_checklist_templates',
                            label: 'Name',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:auto",
                            sorting: true,
                            with:null
                        }
                    ],
                    sortColumn: "name_checklist_templates",
                    sortDirection: "asc",
                },
                tableItems: [],
                modals:{
                    create : {
                        open: false,
                        loading: false,
                        data: {
                            id: null,
                            name_checklist_templates: '',
                            contract_id: 0,
                            is_master: true,
                            group_root_id:null,
                        }
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                currentRoles: 'AuthController/roles',
            }),
        },
        watch: {
            "currentRoles": function(val,old){
                this.tableConfig.controls = {
                    create: this.$checkRole(this.$accessModule.checklist_template_master, 'create'),
                    delete: this.$checkRole(this.$accessModule.checklist_template_master, 'delete')
                }
            },
        },
        created() {},
        methods: {
            /*-- Table callback --------*/
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("v2CheckListTemplateController/getListCheckListTemplate", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the checklist", "danger");
                        reject();
                    })
            },
            async clickToRowItem(item){
                this.modals.create.data = Object.assign({}, item);
                this.$store.commit('v2CheckListTemplateController/setTemplate', item)
                this.gotoItem();
            },
            async importItems(callback){
                const { file, resolve, reject } = await callback();
                await this.$store.dispatch(`v2CheckListTemplateController/uploadFileChecklistTemplate`, {
                    fileChecklistTemplate: file,
                    contract_id : 0
                }).then(response => {
                    let variant = 'success';
                    let msg = this.$notificationV2('importing', 'checklist_template');
                    let result = response.data.data;
                    if(result.data && result.data.count && result.data.count.failed ) {
                        variant = 'danger';
                        msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                    }

                    this.$alertNotification(msg, variant);
                    resolve();
                })
                .catch(error => {
                    reject();
                });
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                await this.$store.dispatch('v2CheckListTemplateController/deleteTemplate', ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'checklist_template'));
                    })
                    .catch(err => {
                        reject();
                    })
            },
            //Save - Update name checklist
            saveData(){
                if(this.modals.create.loading) return;
                if(!this.modals.create.data.name_checklist_templates){
                    this.$alertNotification("The 'Name' field is required", "danger");
                    return;
                }
                this.modals.create.loading = true;
                this.$store.dispatch(`v2CheckListTemplateController/createTemplate`, this.modals.create.data)
                    .then(response => {
                        this.modals.create.loading = false;
                        this.modals.create.open = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        return this.$alertNotification(this.$notificationV2('adding', 'checklist_template'));
                    })
                    .catch(err => {
                        this.modals.create.loading = false;
                        if(err.response) {
                            let msg = "Can't create checklist template!";
                            return this.$alertNotification(msg, "danger");
                        }
                    })
            },
            //Reset create modal
            hideModelCreate(){
                this.modals.create.data = {
                    id: null,
                    name_checklist_templates: '',
                    contract_id: 0,
                    is_master: true
                }
            },
            //Go to detail page
            gotoItem() {
                if(this.modals.create.data.id != null) {
                    return this.$router.push(`${this.$route.path}/${this.modals.create.data.id}`)
                }
                this.$store.commit('v2CheckListTemplateController/setTemplate', this.modals.create.data);
                return this.$router.push(`${this.$route.path}/0`);
            },

        }
    }
</script>
